<template>
	<el-container class="home-container">
		<!-- 头部区域 -->
		<el-header class="home_headerT" id="home_headerT">
			<div style="display: flex;">
				<div class="logoBox">
					<img src="../assets/logo2.jpg" alt="" class="logoImg" />
					<div class="lineClass"></div>
				</div>
				<div class="titleClass">
					电力平台管理端
					<div class="adminClassR">
						<div @click="loginOut" style="cursor: pointer;">{{userName}}</div>
						<i class="iconfont icon-gongren iconClassR"></i>
					</div>
				</div>
			</div>
		</el-header>
		<!--菜单栏区域-->
		<el-header class="home_headerB" id="home_headerB">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="客户总览" name="first"></el-tab-pane>
				<el-tab-pane label="客户管理" name="second"></el-tab-pane>
				<el-tab-pane label="运维管理" name="third"></el-tab-pane>
				<el-tab-pane label="用户管理" name="fourth"></el-tab-pane>
			</el-tabs>
			<!--todo-->
			<i class="iconfont icon-ditu mapClass" @click="largeScreen()"></i>

		</el-header>
		<!-- 页面主体区域 -->
		<el-container>
			<!-- 路由占位符 -->
			<el-main>
				<router-view></router-view>
			</el-main>

		</el-container>
	</el-container>
</template>

<script>
	export default {
		mounted() {
			/*浏览器的返回、前进的处理*/
			window.addEventListener("popstate", (e) => {
				var index = window.location.href.lastIndexOf("#");
				var url = window.location.href.substring(window.location.href.length, index + 1)
				 if(url == '/customerOverview/customerOverview') { //客户总览
					this.activeName = 'first'
					window.sessionStorage.setItem('activeName', 'first')
				} else if(url == '/customer/customer' || url.indexOf('/customer/customerC') != -1 || url.indexOf('/customer/equipment') != -1 || url.indexOf('/customer/gateway') != -1 || url.indexOf('/customer/list') != -1) { //客户管理
					this.activeName = 'second'
					window.sessionStorage.setItem('activeName', 'second')
				}else if(url == '/operations/operations') { //运维管理
					this.activeName = 'third'
					window.sessionStorage.setItem('activeName', 'third')
				} else if(url == '/manager/manager') { //用户管理
					this.activeName = 'fourth'
					window.sessionStorage.setItem('activeName', 'fourth')
				}
			}, false);
			/*监听窗口宽度的变化*/
			window.onresize = () => {
				return(() => {})();
			};
		},
		data() {
			return {
				// 是否折叠
				isCollapse: false,
				// 被激活的链接地址
				activePath: '',
				userName: '', //用户名
				activeIndex: '1',
				activeIndex2: '1',
				activeName: 'fourth',
				userName: '', //用户名
			}
		},
		created() {
			if(window.innerWidth < 767) {
				this.isCollapse = true
			}
			this.activeName = window.sessionStorage.getItem('activeName')
			if(!this.activeName) {
				this.activeName = 'fourth'
			}
			this.activePath = window.sessionStorage.getItem('activePath')
			this.userName = window.sessionStorage.getItem('manager')
		},
		methods: {
			handleClick(num) {
				if(num.label == '客户总览') {
					window.sessionStorage.setItem('activeName', 'first')
					this.$router.push({
						path: '/customerOverview/customerOverview',
						name: 'CustomerOverview'
					})
				} else if(num.label == '客户管理') {
					window.sessionStorage.setItem('activeName', 'second')
					this.$router.push({
						path: '/customer/customer',
						name: 'Customer'
					})
				}  else if(num.label == '运维管理') {
					window.sessionStorage.setItem('activeName', 'third')
					this.$router.push({
						path: '/operations/operations',
						name: 'Operations'
					})
				}else if(num.label == '用户管理') {
					window.sessionStorage.setItem('activeName', 'fourth')
					this.$router.push({
						path: '/manager/manager',
						name: 'Manager'
					})
				}
			},
			loginOut() {
				window.sessionStorage.clear();
				this.$router.push({
					path: '/login',
					name: 'Login'
				})
			},
			largeScreen(){
				this.$router.push({
					path: '/largeScreen',
					name: 'LargeScreen'
				})
			},
		}
	}
</script>

<style>
	.home-container {
		height: 100%;
		overflow: auto;
		/*overflow-y: hidden;*/
	}
	
	body {
		margin: 0;
	}
	
	html {
		height: 100%;
		margin: 0;
		padding: 0;
	}
	
	el-container {
		margin: 0;
		padding: 0;
	}
	
	.home_headerT {
		padding: 0;
		margin: 0;
		position: relative;
		text-align: left;
		height: 46px!important;
		line-height: 46px;
		background-color: #fff;
		border-bottom: 1px solid #3F3F3F;
	}
	
	.logoBox {
		position: relative;
		flex: 4;
		display: inline-block;
		height: 100%;
		vertical-align: top;
	}
	
	.logoImg {
		margin-left: 26%;
		padding-top: 2%;
		width: 30px;
		height: 30px;
	}
	
	.lineClass {
		position: absolute;
		top: 4px;
		right: 0;
		height: 70%;
		width: 1px;
		background-color: #BDBDBD;
	}
	
	.titleClass {
		flex: 15;
		display: inline-block;
		vertical-align: top;
		padding-left: 2%;
	}
	
	.adminClass {
		position: relative;
		display: inline-block;
		width: 16%;
		height: 100%;
		vertical-align: top;
		background-color: pink;
	}
	
	.iconClassR {
		position: absolute;
		top: 0;
		left: -30px;
		color: #1A4991;
		font-size: 20px;
	}
	
	.adminClassR {
		color: #000!important;
		position: absolute;
		top: 0;
		right: 1%;
	}
	
	.home_headerT span {
		color: #fff;
	}
	
	.home_headerB {
		position: relative;
		height: 40px!important;
		background-color: #282828;
		text-align: left;
		line-height: 40px;
		border-bottom: 1px solid #3F3F3F;
		background-color: #1A4991;
	}
	
	.home_headerB span {
		color: #fff;
	}
	
	.el-tabs {
		background-color: #1A4991;
		height: 100%;
		width: 50%;
		margin-left: 25%;
		font-size: 13px;
	}
	
	.el-tabs__item.is-active {
		color: #fff!important;
	}
	
	.el-tabs__item {
		font-size: 13px;
		text-align: center;
		padding: 0 71px;
		color: #fff;
	}
	
	.el-tabs__item:hover {
		color: #fff;
	}
	
	.el-tabs__active-bar {
		bottom: 5px!important;
		height: 3px;
		background-color: #fff;
		z-index: 1;
	}
	
	.el-tabs__nav-wrap::after {
		0 height: 0!important;
		background-color: transparent;
	}
	
	.mapClass {
		position: absolute;
		top: 0;
		right: 10px;
		color: #fff;
		font-size: 18px;
		cursor: pointer;
	}
	
	.el-main {
		background-color: #FBFBFB;
		padding: 14px;
		overflow-y: hidden;
		height: 100%;
		padding: 0;
		margin: 0;
	}
	/*滚动条的样式*/
	
	.home-container::-webkit-scrollbar {
		width: 10px;
	}
	
	.home-container::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.2);
	}
	
	.home-container::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}
	/*媒体查询*/
	
	@media screen and (max-width: 767px) {}
	/*@media screen and (max-width: 1320px) {
		.home_headerB .el-tabs__item {
			padding: 0 20px;
		}
	}*/
</style>


// WEBPACK FOOTER //
// src/components/Home.vue